<template>
  <div class="container mt-5">
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-3">
                <h4>{{ 'locales' | t }}</h4>
              </div>
              <div class="col-sm-8">
                <v-select multiple="multiple" v-model="active_locales" :options="options"></v-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ts-check
import languages from '@cospired/i18n-iso-languages';

// @ts-ignore
languages.registerLocale(require('@cospired/i18n-iso-languages/langs/en.json'));

export default {
  props: {
    template_type: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      options: [],
      all_languages: languages.getNames('en')
    };
  },
  computed: {
    /**
     * English ('en') is removed in getter and added in setter. This is because english is default, and should therefor not be removable in dropdown
     */
    active_locales: {
      get() {
        const active_locales = [];
        this.template_type.active_locales.forEach((locale) => {
          if (locale === 'en') {
            return;
          }

          active_locales.push({
            label: this.all_languages[locale],
            code: locale
          });
        });

        return active_locales;
      },
      set(newValue) {
        const active_locales = Object.entries(newValue).map((entry) => entry[1].code);
        active_locales.push('en');

        this.$set(this.template_type, 'active_locales', active_locales);
      }
    }
  },
  created() {
    this.set_options();
  },
  methods: {
    set_options() {
      Object.entries(languages.getNames('en')).forEach((entry) => {
        this.options.push({ label: entry[1], code: entry[0] });
      });
    }
  }
};
</script>
